import "./CalendarRequest.css";
import * as React from 'react';
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Link } from 'office-ui-fabric-react';
import * as analytics from '../../../analytics';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { UserState } from '../../../store/User';
import { HubspotInlineWidget, HubspotEventListener } from '../HubspotMeeting';

type OwnProps = {
    title: JSX.Element;
    description: JSX.Element;
    details: JSX.Element;
    skipText: string;

    eventPath: string;
    eventName: string;
}
type StateProps = {
    user: UserState
}
type Props = OwnProps & StateProps & RouteComponentProps<{}>;

const EVENT_SCHEDULED_TIMEOUT = 3000;

const CalendarRequest = (props: Props) => {

    const onBack = React.useCallback(() => {
        props.history.push(props.location.state?.source ? props.location.state.source : "/");
    }, []);

    const onSkip = React.useCallback(() => {
        analytics.track(props.eventName, { success: false });
        onBack();
    }, []);

    const onEventScheduled = React.useCallback(() => {
        analytics.track(props.eventName, { success: true });
        setTimeout(() => onBack(), EVENT_SCHEDULED_TIMEOUT);
    }, [props.eventName, onBack]);

    return <div className='calendar-request'>
        <div className="content full-width">
            <div className="title">
                {props.title}
            </div>
            <div className="description">{props.description}</div>
            <div className="details">{props.details}</div>
            <div className="navigation">
                <Link onClick={onSkip} className="skip">
                    {props.skipText}
                </Link>
            </div>
        </div>
        <div className="embed">
            <HubspotEventListener onEventScheduled={onEventScheduled}>
                <HubspotInlineWidget
                    url={props.eventPath}
                    prefill={{
                        email: props.user.email,
                        firstName: props.user.name?.split(' ')[0],
                        lastName: props.user.name?.split(' ').slice(1).join(' ')
                    }}
                />
            </HubspotEventListener>
            <div className="hint">
                You'll be redirected to the app after you book a call anyway
            </div>
        </div>
    </div>;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        user: state.user
    }
}

export default withRouter<OwnProps>(connect(mapStateToProps)(CalendarRequest));